import React from "react";
import PropTypes from "prop-types";
import { Button } from "pepsico-ds";

const DataTableToolbar = ({ onResetAll, toolbarActions = [], selectedRowsCount = 0 }) => (
  <div className="datatable-toolbar" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
    <Button
      className="datatable-toolbar__reset"
      variant="text"
      color="primary"
      size="medium"
      onClick={onResetAll}
      disableRipple
    >
      Reset All
    </Button>
    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
      {toolbarActions.map((action, index) => (
        <Button
          key={`toolbar-action-${index}`}
          className={`datatable-toolbar__${action.id || action.label.toLowerCase().replace(/\s+/g, '-')}`}
          variant={action.variant || "outlined"}
          color={action.color || "primary"}
          size={action.size || "medium"}
          onClick={action.onClick}
          disabled={action.requiresSelection ? selectedRowsCount === 0 : action.disabled}
          iconLeading={action.icon}
        >
          {action.label}
        </Button>
      ))}
    </div>
  </div>
);

DataTableToolbar.propTypes = {
  onResetAll: PropTypes.func.isRequired,
  toolbarActions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      icon: PropTypes.string,
      variant: PropTypes.string,
      color: PropTypes.string,
      size: PropTypes.string,
      disabled: PropTypes.bool,
      requiresSelection: PropTypes.bool
    })
  ),
  selectedRowsCount: PropTypes.number
};

export default DataTableToolbar;
